import { render, staticRenderFns } from "./addModules.vue?vue&type=template&id=5c986910&scoped=true"
import script from "./addModules.vue?vue&type=script&lang=js"
export * from "./addModules.vue?vue&type=script&lang=js"
import style0 from "./addModules.vue?vue&type=style&index=0&id=5c986910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c986910",
  null
  
)

export default component.exports